/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateFileStorePathParams,
	CandidateFileStoreRequest,
	CandidateFileStoreResponse,
} from '../types/CandidateFileStore'
import { buildFormData } from '../utils/form-data'

/**
 * POST /candidates/:candidateId/files
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateFileController.php CandidateFileController::store
 */
export async function candidateFileStore(
	candidateId: CandidateFileStorePathParams['candidateId'],
	data: CandidateFileStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateFileStoreResponse>> {
	return axiosInstance.post(`/candidates/${candidateId}/files`, buildFormData(data), {
		headers: { 'Content-Type': 'multipart/form-data' },
		...config,
	})
}
